import { Loader } from "lucide-react";

export const LoadingSpinner = ({ size = 40, className = "" }) => {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <Loader size={size} className="animate-spin text-indigo-500" />
    </div>
  );
};
